var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-vant-area"},[_c('van-area',{attrs:{"area-list":_vm.areaList},on:{"cancel":_vm.cancelArea,"confirm":_vm.confirmArea}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }